function getActiveIdsFromAll(allIds = [], inactiveIds = []) {
  if (!Array.isArray(allIds) || allIds.length === 0) return []
  const inactiveSet = new Set(inactiveIds)
  return allIds.filter(id => !inactiveSet.has(id))
}

function getNextInactiveIds(currentActiveIds = [], nextActiveIds = [], currentInactiveIds = []) {
  const currentActiveSet = new Set(currentActiveIds)
  const nextActiveSet = new Set(nextActiveIds)
  const toggledIds = [...new Set([...currentActiveIds, ...nextActiveIds])]
    .filter(id => currentActiveSet.has(id) !== nextActiveSet.has(id))

  const nextInactiveSet = new Set(currentInactiveIds)
  toggledIds.forEach((id) => {
    if (nextActiveSet.has(id)) {
      nextInactiveSet.delete(id)
    } else {
      nextInactiveSet.add(id)
    }
  })

  return [...nextInactiveSet]
}

function resolveActiveIds(allIds = [], storedActiveIds = []) {
  if (!Array.isArray(allIds) || allIds.length === 0) return []
  if (!Array.isArray(storedActiveIds) || storedActiveIds.length === 0) return allIds
  return storedActiveIds
}

function getNextActiveIds(allIds = [], nextActiveIds = []) {
  if (Array.isArray(allIds) && allIds.length > 0 && nextActiveIds.length >= allIds.length) return []
  return nextActiveIds
}

export {
  getActiveIdsFromAll,
  getNextInactiveIds,
  resolveActiveIds,
  getNextActiveIds,
}
